import { http } from "./httpServices";
import { OUTLET } from "./constants";

export function fetchAllOutlets(
  activePage: number,
  limitCount: number,
  queryString: string
) {
  return http.get(
    `${OUTLET}?searchText=${queryString}&page=${activePage}&limit=${limitCount}`
  );
}

export function fetchOutletFromId(id: any) {
  return http.get(`${OUTLET}/${id}`);
}

export function addOutlet(data: any) {
  return http.post(OUTLET, data);
}

export function updateOutlet(data: any, id: string | any) {
  return http.put(`${OUTLET}/${id}`, data);
}

export function addSoldout(data: any) {
  return http.post("/soldout", data);
}

export function getSoldoutList(id: any) {
  return http.get(`/soldout/list`, {
    params: {
      outletId: id,
    },
  });
}

export function cancelSoldout(id: any) {
  return http.put(`/soldout/${id}`, { isActive: false });
}
